// extracted by mini-css-extract-plugin
export var childrenContainer = "VideoContainer-module--children-container--b0ead";
export var fluid = "VideoContainer-module--fluid--54a3c";
export var hidden = "VideoContainer-module--hidden--0246e";